import React from "react";
import "./InterviewInstructions.scss";
import Header from "../../Common/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faMicrophone,
  faMicrophoneSlash,
  faVideo,
  faVideoSlash,
} from "@fortawesome/free-solid-svg-icons";
import useInterviewInstructions from "./useInterviewInstructions";
export default (props) => {
  const {
    cameraAccess,
    interviewStart,
    permissionAllowed,
    internetStatus,
    vidRef,
    isAllQuestionsNotAnswered,
    onStartClick,
  } = useInterviewInstructions(props);


  const user = JSON.parse(localStorage.getItem("jigsawUser"));

  return (
    <>
      {/* <Header /> */}
      <div className="interviews-instructions-wrapper bg-dark text-grey-4">
        <div className="container">
          <div className="row align-items-center  pt-5">
            <div className="col-lg-8">
              <div className="video-container position-relative">
                {permissionAllowed ? (
                  <video
                    id="player"
                    ref={vidRef}
                    autoPlay
                    style={{ width: "100%", height: 500, objectFit: "cover" }}
                    muted={'muted'}
                  ></video>
                ) : (
                  <img
                    src="./assets/images/video-thumbnail.png"
                    alt="video thumbnail"
                  />
                )}
                <ul className="video-controls d-flex align-items-center justify-content-center">
                  <li className="mr-2">
                    <button className="bg-transparent border-0 p-3 text-white">
                      {cameraAccess && permissionAllowed ? (
                        <FontAwesomeIcon icon={faMicrophone} />
                      ) : (
                        <FontAwesomeIcon icon={faMicrophoneSlash} />
                      )}
                    </button>
                  </li>
                  <li>
                    <button className="bg-transparent border-0 p-3 text-white">
                      {cameraAccess && permissionAllowed ? (
                        <FontAwesomeIcon icon={faVideo} />
                      ) : (
                        <FontAwesomeIcon icon={faVideoSlash} />
                      )}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 py-4">
              <h3 className="mb-3 mt-3 mt-lg-0 text-light">
                Interview Instructions
              </h3>
              {cameraAccess ? (
                <div>
                  {interviewStart ? (
                    <div>
                      <ul className="text-grey-4">
                        <li className="d-flex align-items-center-start mb-2">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className={`text-primary mr-3 mt-2`}
                          />
                          After starting, you’ll have time to read the question
                          and record when you’re comfortable
                        </li>
                        {/* <li className="d-flex align-items-center-start mb-2">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="text-primary mr-3 mt-2"
                          />
                          You’re able to take breaks in between questions
                        </li> */}
                        <li className="d-flex align-items-center-start mb-2">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="text-primary mr-3 mt-2"
                          />
                          All recordings must be submitted by the specific date
                        </li>
                      </ul>
                      <div className="actions mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            onStartClick();
                          }}
                        >
                          {isAllQuestionsNotAnswered
                            ? "Start Interview"
                            : " Resume Interview"}
                        </button>
                        {/* <button className="btn btn-outline-light  ml-3">
                          Test your network
                        </button> */}
                      </div>
                    </div>
                  ) : (
                    <ul className="text-grey-4">
                      <li className="d-flex align-items-center-start mb-2">
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className={`text-primary mr-3 mt-2`}
                        />
                        Audio and Video Compatible Device
                      </li>
                      <li className="d-flex align-items-center-start mb-2">
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className={`${
                            permissionAllowed ? "text-primary" : "text-disabled"
                          } mr-3 mt-2`}
                        />
                        Camera and Audio permissions allowed
                      </li>
                      <li className="d-flex align-items-center-start mb-2">
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className={`${
                            internetStatus ? "text-primary" : "text-disabled"
                          } mr-3 mt-2`}
                        />
                        {internetStatus
                          ? "Device connected to the internet."
                          : "Please connect device to the internet and reload."}
                      </li>
                    </ul>
                  )}
                </div>
              ) : (
                <ul className="text-grey-4">
                  <li className="d-flex align-items-center-start mb-2 red">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="text-primary mr-3 mt-2"
                    />
                    Please connect with a device having camera and audio
                    supported.
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
